export default "__VITE_ASSET__1MedzZpg__"